var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { FunnelLine } from './modules/FunnelLine';
import { FunnelReward } from './modules/FunnelReward';
import { FunnelPreload } from './modules/FunnelPreload';
import { FunnelIncoming } from './modules/FunnelIncoming';
import { FunnelBranding } from './modules/FunnelBranding';
import { FunnelMixed } from './order/FunnelMixed';
import { FunnelSuccession } from './order/FunnelSuccession';
export class TrayFunnel {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    funnelManualRefresher = 0;
    get tray() {
        return this.parent;
    }
    get app() {
        return this.tray.app;
    }
    get funnelLine() {
        return new FunnelLine(this);
    }
    get funnelReward() {
        return new FunnelReward(this);
    }
    get funnelBranding() {
        return new FunnelBranding(this);
    }
    get funnelIncoming() {
        return new FunnelIncoming(this);
    }
    funnelPreload = new FunnelPreload(this);
    get funnelMixed() {
        return new FunnelMixed(this);
    }
    get funnelOrderSuccession() {
        return new FunnelSuccession(this);
    }
    get numberOfRemainingQuestions() {
        return this.funnelIncoming.numberOfIncomingAnswers;
    }
    recalculateFunnel() {
        this.funnelManualRefresher++;
    }
}
__decorate([
    observable
], TrayFunnel.prototype, "funnelManualRefresher", void 0);
__decorate([
    memoize
], TrayFunnel.prototype, "funnelLine", null);
__decorate([
    memoize
], TrayFunnel.prototype, "funnelReward", null);
__decorate([
    memoize
], TrayFunnel.prototype, "funnelBranding", null);
__decorate([
    memoize
], TrayFunnel.prototype, "funnelIncoming", null);
__decorate([
    memoize
], TrayFunnel.prototype, "funnelMixed", null);
__decorate([
    memoize
], TrayFunnel.prototype, "funnelOrderSuccession", null);
__decorate([
    computed
], TrayFunnel.prototype, "numberOfRemainingQuestions", null);
__decorate([
    action.bound
], TrayFunnel.prototype, "recalculateFunnel", null);
